// Services
import apiClient from '@/services/AccountClient'

export default {
  fetchAll (params = {}, options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/deposits',
      params,
      options
    )
  },
  fetchById (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/deposits/${id}`
    )
  },
  update (id, paymentId, openingDate, expirationDate) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/deposits/${id}/update`,
      { paymentId: paymentId, openingDate, expirationDate }
    )
  },
  setStatus (id, status) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/deposits/${id}/status`,
      { status }
    )
  },
  decline (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/deposits/${id}/decline`
    )
  },
  calculateExpirationDate (openingDate, maturity, options) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/deposits/calculate-expiration-date',
      { openingDate, maturity },
      options
    )
  },
  fetchRates () {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/deposits/rates'
    )
  },
  saveRates (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/deposits/rates',
      data
    )
  }
}
